// extracted by mini-css-extract-plugin
module.exports = {"pageHeader":"page-header-module--pageHeader--2t5o5","pageHeaderText":"page-header-module--pageHeaderText--VhEPE"};